import React, { useEffect, useState } from 'react';
import { Client } from '../../../types';
import style from './ModalWindow.module.css';
import DeleteLogo from './icons/DeleteLogo';
import DetailsLogo from './icons/DetailsLogo';
// import InvitationLogo from './icons/InvitationLogo';

interface ModalWindowProps {
  client: Client | null;
  onClose: () => void;
  onDetails: () => void;
  onSendInvitation: () => void;
  onDelete: () => void;
  buttonRef: { current: HTMLButtonElement | null };
}

const ModalWindow: React.FC<ModalWindowProps> = ({
  client,
  onClose,
  onDetails,
  onSendInvitation,
  onDelete,
  buttonRef,
}) => {
  const [position, setPosition] = useState<{ top: string; left: string }>({
    top: '0px',
    left: '0px',
  });

  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const modal = document.querySelector(`.${style.modalContent}`);
      if (
        modal &&
        buttonRef.current &&
        !modal.contains(event.target as Node) &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [buttonRef, onClose]);

  useEffect(() => {
    if (buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const modal = document.querySelector(
        `.${style.modalContent}`,
      ) as HTMLElement;

      if (modal) {
        const modalHeight = modal.offsetHeight;
        const modalWidth = modal.offsetWidth;
        const screenHeight = window.innerHeight;
        const screenWidth = window.innerWidth;

        let top = buttonRect.bottom + window.scrollY;
        let left = buttonRect.left + window.scrollX;

        if (top + modalHeight > screenHeight) {
          top = buttonRect.top + window.scrollY - modalHeight;
        }

        if (left + modalWidth > screenWidth) {
          left = screenWidth - modalWidth;
        }

        setPosition({
          top: `${top}px`,
          left: `${left - 42}px`,
        });
      }
    }
  }, [buttonRef]);

  if (!client) return null;

  return (
    <div className={style.modalOverlay}>
      <div
        className={style.modalContent}
        style={{ top: position.top, left: position.left }}
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={onDetails} className={style.detailButton}>
          <DetailsLogo />
          Деталі
        </button>
        {/* <button
          onClick={onSendInvitation}
          className={style.inviteButton}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <InvitationLogo />
          Надіслати запрошення
        </button>
        <div
          className={style.borderBottom}
          style={{ display: isHovered ? 'none' : 'block' }}
        ></div> */}
        <button
          onClick={onDelete}
          className={style.delateButton}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <DeleteLogo />
          Видалити
        </button>
      </div>
    </div>
  );
};

export default ModalWindow;
